import i18n from "@/i18n/index.js";

const columns = [
    {
        name: "name",
        label: i18n.t("admin.manageUIs.name"),
        field: "name",
        align: "left",
        sortable: true
    },
    {
        name: "description",
        label: i18n.t("admin.manageUIs.description"),
        field: "description",
        align: "left",
        sortable: true
    },
    {
        name: "owner",
        label: i18n.t("admin.manageUIs.owner"),
        field: "owner",
        align: "left",
        sortable: true
    },
    {
        name: "usedOn",
        label: i18n.t("admin.manageUIs.usedOn"),
        field: "usedOnApps",
        align: "left",
        sortable: true
    },
    {
        name: "icons",
        label: "",
        field: ""
    }
];

export default columns;
